import React, { useEffect, useState } from "react";
import { axiosInstance } from "common/network";
import {
  Box,
  Stack,
  Modal,
  Button,
  Typography,
  Divider,
} from "@mui/material";
import { PRIMARY_COLOR_HEX } from "theme/palette";

const ExpiredDateModal = (props) => {
  const { accountUuid, packageUuid } = props;
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    props.handleClose();
  };

  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  const handleConfirm = () => {
    const body = {
      package_uuid: packageUuid,
    };

    const url =
      process.env.REACT_APP_API_ROOT +
      `v3/accounts/${accountUuid}/packages/expire`;

    try {
      axiosInstance
        .put(url, body)
        .then((response) => {
          console.log("expired date success: ", response);
          handleClose();
          props.handleExpirePackageSuccess();
        })
        .catch((e) => {
          console.log("expired date error:", e);
          handleClose();
        });
    } catch (err) {
      console.log("expired date error:", err);
      handleClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="expire-package-title"
      aria-describedby="expire-package-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "100%",
          maxWidth: 420,
          bgcolor: "background.paper",
          borderRadius: 1,
          boxShadow: 24,
          overflow: "hidden",
        }}
      >
        <Box sx={{ px: 3, pt: 2.5, pb: 1.5 }}>
          <Typography
            id="expire-package-title"
            variant="h6"
            sx={{ fontWeight: 600 }}
          >
            Expire package
          </Typography>
        </Box>
        <Divider sx={{ borderBottomWidth: 3, borderColor: PRIMARY_COLOR_HEX }} />

        <Box sx={{ px: 3, py: 2.5 }}>
          <Typography id="expire-package-description" variant="body2">
            This action will expire the current package. Are you sure you want to
            continue?
          </Typography>
        </Box>

        <Divider />
        <Stack
          direction="row"
          justifyContent="flex-end"
          spacing={1.5}
          sx={{ px: 3, py: 2 }}
        >
          <Button onClick={handleClose} sx={{ color: PRIMARY_COLOR_HEX }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            disableElevation
            onClick={handleConfirm}
            sx={{
              bgcolor: PRIMARY_COLOR_HEX,
              color: "#fff",
              "&:hover": { bgcolor: PRIMARY_COLOR_HEX },
            }}
          >
            Confirm
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default ExpiredDateModal;
